import { render } from "./AssistView.vue?vue&type=template&id=a703a466&ts=true"
import script from "./AssistView.vue?vue&type=script&lang=ts"
export * from "./AssistView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__